import { withAppContext, withMemberContext } from '@/config/site'
import request from '@/utils/request'

/**
 * 获取课程推荐资源列表
 * @param {number} courseId - 课程ID
 * @param {object} payload - 其他参数
 * @returns {Promise<array>} 推荐资源列表
 */
export const fetchCourseResourceList = async (courseId, payload = {}) => {
  const response = await request('/page/course/resource/index', {
    data: withAppContext({
      course_id: courseId,
      ...payload
    })
  })

  return Array.isArray(response.data) ? response.data : []
}

/**
 * 获取章节推荐资源列表
 * @param {number} courseId - 课程ID
 * @param {number} chapterId - 章节ID
 * @param {object} payload - 其他参数
 * @returns {Promise<array>} 章节推荐资源列表
 */
export const fetchChapterResourceList = async (courseId, chapterId, payload = {}) => {
  const response = await request('/page/course/resource/by-chapter', {
    data: withAppContext({
      course_id: courseId,
      chapter_id: chapterId,
      ...payload
    })
  })

  return Array.isArray(response.data) ? response.data : []
}

/**
 * 获取资源详情
 * @param {number} id - 资源ID
 * @param {object} payload - 其他参数
 * @returns {Promise<object>} 资源详情
 */
export const fetchResourceDetail = async (id, payload = {}) => {
  const response = await request('/page/course/resource/detail', {
    data: withAppContext({
      id,
      ...payload
    })
  })

  return response.data || {}
}

export const forwardMaterial = async (payload = {}) => {
  const response = await request('/page/material/forward', {
    data: withMemberContext(payload)
  })

  return response.data || {}
}

export const createMaterialShareLink = async (payload = {}) => {
  const response = await request('/page/material/share-link', {
    data: withMemberContext(payload)
  })

  return response.data || {}
}

export const fetchMaterialShareInfo = async (token, payload = {}) => {
  const response = await request('/page/material/share-info', {
    data: withAppContext({
      token,
      ...payload
    })
  })

  return response.data || {}
}
